<div style="box-shadow: none !important">
  <ng-autocomplete
    [data]="supplier"
    [searchKeyword]="keyword"
    historyIdentifier="supplier"
    [itemTemplate]="itemTemplate"
    placeholder="Converter"
    (inputCleared)="onClearSearch($event)"
    [notFoundTemplate]="notFoundTemplate"
    [(ngModel)]="setValue"
    (selected)="updateValue($event)"
  >
  </ng-autocomplete>
  <ng-template #itemTemplate let-item>
    <div class="item"><span [innerHTML]="item.name"></span> &nbsp;</div>
  </ng-template>

  <ng-template #notFoundTemplate let-notFound>
    <div [innerHTML]="notFound"></div>
  </ng-template>
</div>
